var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isDisplayed)?_c('iw-input-checkbox',{attrs:{"input-label":_vm.$t('sea_view'),"name":"has-sea-view"},model:{value:(_vm.hasSeaView),callback:function ($$v) {_vm.hasSeaView=$$v},expression:"hasSeaView"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }